import { Scrollbar } from 'react-scrollbars-custom';
import React from 'react';
import classNames from 'classnames';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';

export default function List({ data, className, modifier, scrollbarClassName, scrollbarModifier }) {
  return (
    <div
      className={classNames('universal-modal__list', className, ...combineModifiers('universal-modal__list', modifier))}
    >
      <Scrollbar>
        <div
          className={classNames(
            'universal-modal__list-block',
            scrollbarClassName,
            ...combineModifiers('universal-modal__list-block', scrollbarModifier),
          )}
        >
          {data.map((item, index) => {
            const { Component = 'div', props = {} } = item ?? {};
            return <Component key={props.key ?? index} {...props} />;
          })}
        </div>
      </Scrollbar>
    </div>
  );
}
